import React, { useEffect, useState, useCallback } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Button } from '../../../components-reactjs/Button';

import { Creators as toastActions } from '../../../store/ducks/toast';
import { FixedPrice } from './FreteFixedPrice';
import { FreteList } from './FreteList';
import { Modal } from '../../../components-reactjs/Modal';
import { CircularProgressIndicator } from '../../../components-reactjs/CircularProgressIndicator';
import { useToggle } from '../../../hooks/useToggle';
import { FretesAddItem } from './FreteAddItem';
import { TIPO_FRETE } from '../../../constants/configuracao-frete';
import {
    getFrete,
    createCondicaoFrete,
    deleteCondicaoFrete,
    activeTipoCondicao
} from '../api';

import {
    Header,
    HeaderTitle,
    SectionTitles,
    RadioInput,
    RadioRow,
    ButtonContainer
} from '../styles';

import { FreteContentContainer, ScrollConfig } from './styles';

const FretesComponent = ({ addToast, ...props }) => {
    const [toggle, handleToggle] = useToggle(false);
    const [freteCfg, setFreteCfg] = useState();
    const [selectedCfg, setSelectedCfg] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingSave, setIsloadingSave] = useState(false);

    const findActive = useCallback((fretes) => {
        const selected = fretes.find((frete) => frete.fgAtivo === true);
        return selected;
    }, []);

    const changeActiveCfg = useCallback(async (newFreteCfg, selected) => {
        let newFretesCfgState = newFreteCfg;
        if (selected.condicaoFrete.length) {
            newFretesCfgState = newFreteCfg.map((frete) => {
                if (
                    frete.idTipoCobrancaFrete !== selected.idTipoCobrancaFrete
                ) {
                    return { ...frete, fgAtivo: false };
                }

                return { ...frete, fgAtivo: true };
            });
        }
        setFreteCfg(newFretesCfgState);
    }, []);

    const handleChangeSelect = useCallback(
        (tipoFrete) => {
            if (selectedCfg && tipoFrete === selectedCfg.idTipoCobrancaFrete) {
                return;
            }

            const newSelect = freteCfg.find((frete) => {
                return frete.idTipoCobrancaFrete === tipoFrete;
            });

            const newSelectedState = {
                ...newSelect,
                fgAtivo: !!newSelect.condicaoFrete.length
            };
            if (!newSelectedState.condicaoFrete.length) {
                addToast({
                    text: 'Cadastre uma condição',
                    theme: 'error'
                });
            }
            setSelectedCfg(newSelectedState);
            changeActiveCfg(freteCfg, newSelectedState);
        },
        [freteCfg, selectedCfg]
    );

    const handlerFixedValue = useCallback(
        async (condicaoFreteItem) => {
            try {
                if (selectedCfg.condicaoFrete.length) {
                    const [condicaoFreteToDelete] = selectedCfg.condicaoFrete;

                    const { data: dataDelete, status: statusDelete } =
                        await deleteCondicaoFrete(
                            selectedCfg.idTipoCobrancaFrete,
                            condicaoFreteToDelete.idCondicaoFrete
                        );

                    if (statusDelete !== 200) {
                        throw dataDelete.errorMessage;
                    }
                }

                const { data: dataCreate, status: statusCreate } =
                    await createCondicaoFrete(
                        selectedCfg.idTipoCobrancaFrete,
                        condicaoFreteItem
                    );

                if (statusCreate !== 201) {
                    throw dataCreate.errorMessage;
                }

                const newStateCondicao = [
                    {
                        ...condicaoFreteItem,
                        idCondicaoFrete: dataCreate.idCondicaoFrete
                    }
                ];

                const newSelectedCfg = {
                    ...selectedCfg,
                    fgAtivo: true,
                    condicaoFrete: newStateCondicao,
                    tpPrioridade: 1
                };

                const indexSelected = freteCfg.findIndex(
                    (frete) =>
                        frete.idTipoCobrancaFrete ===
                        selectedCfg.idTipoCobrancaFrete
                );

                const newFreteCfg = [...freteCfg];
                newFreteCfg[indexSelected] = newSelectedCfg;

                setSelectedCfg(newSelectedCfg);
                changeActiveCfg(newFreteCfg, newSelectedCfg);

                addToast({
                    text: 'Condição de frete alterada com sucesso',
                    theme: 'success'
                });
            } catch (error) {
                addToast({
                    text: error,
                    theme: 'error'
                });
            }
        },
        [selectedCfg, freteCfg]
    );

    const handlerAddItem = useCallback(
        async (condicaoFreteItem) => {
            try {
                const { data, status } = await createCondicaoFrete(
                    selectedCfg.idTipoCobrancaFrete,
                    condicaoFreteItem
                );

                if (status !== 201) {
                    throw data.errorMessage;
                }

                const newState = [
                    ...selectedCfg.condicaoFrete,
                    {
                        ...condicaoFreteItem,
                        idCondicaoFrete: data.idCondicaoFrete
                    }
                ];

                addToast({
                    text: 'Condição de frete adicionada com sucesso',
                    theme: 'success'
                });
                const newSelectedCfg = {
                    ...selectedCfg,
                    condicaoFrete: newState,
                    fgAtivo: true
                };

                const indexSelected = freteCfg.findIndex(
                    (frete) =>
                        frete.idTipoCobrancaFrete ===
                        selectedCfg.idTipoCobrancaFrete
                );

                const newFreteCfg = [...freteCfg];
                newFreteCfg[indexSelected] = newSelectedCfg;

                setSelectedCfg(newSelectedCfg);
                changeActiveCfg(newFreteCfg, newSelectedCfg);
            } catch (error) {
                addToast({
                    text: error,
                    theme: 'error'
                });
            }
        },
        [selectedCfg, changeActiveCfg, freteCfg]
    );

    const excludeHandler = async (indexOfCondicaoItem) => {
        const { idTipoCobrancaFrete, condicaoFrete } = selectedCfg;
        const idCondicao = condicaoFrete[indexOfCondicaoItem].idCondicaoFrete;

        try {
            const { data, status } = await deleteCondicaoFrete(
                idTipoCobrancaFrete,
                idCondicao
            );

            if (status !== 200) {
                throw data.message;
            }

            addToast({
                text: data.message,
                theme: 'error'
            });

            const newCondicaoFrete = [...condicaoFrete];
            newCondicaoFrete.splice(indexOfCondicaoItem, 1);
            const newState = {
                ...selectedCfg,
                condicaoFrete: newCondicaoFrete
            };
            setSelectedCfg(newState);
            const indexSelected = freteCfg.findIndex(
                (frete) =>
                    frete.idTipoCobrancaFrete ===
                    selectedCfg.idTipoCobrancaFrete
            );
            const newFreteCfg = [...freteCfg];
            newFreteCfg[indexSelected] = newState;
            setFreteCfg(newFreteCfg);
        } catch (error) {
            addToast({
                text: error,
                theme: 'error'
            });
        }
    };

    const sendChangeOption = useCallback(async () => {
        try {
            if (!selectedCfg) {
                return addToast({
                    text: 'Selecione uma opção para salvar',
                    theme: 'error'
                });
            }
            setIsloadingSave(true);
            const { data, status } = await activeTipoCondicao(
                selectedCfg.idTipoCobrancaFrete
            );

            if (status !== 200) {
                throw data.errorMessage;
            }
            addToast({
                text: data.message,
                theme: 'success'
            });
            setIsloadingSave(false);
        } catch (error) {
            addToast({
                text: error,
                theme: 'error'
            });
        }
    }, [selectedCfg]);

    const verifyData = useCallback(({ tipoCondicaoFrete: data = [] }) => {
        let allCfg = [];
        for (let i = 1; i <= 3; i++) {
            let cfg = data.find(
                ({ idTipoCobrancaFrete }) => idTipoCobrancaFrete === i
            );
            if (cfg) {
                allCfg.push(cfg);
            } else {
                let newCfg = {
                    idTipoCobrancaFrete: i,
                    condicaoFrete: [],
                    fgAtivo: false
                };
                allCfg.push(newCfg);
            }
        }
        return allCfg;
    }, []);

    useEffect(() => {
        async function fetchApi() {
            setIsLoading(true);

            const { data } = await getFrete();
            const { tipoCondicaoFrete = [] } = data;
            if (data) {
                const selected = findActive(tipoCondicaoFrete);

                const dataCompleted = verifyData(data);

                setFreteCfg(dataCompleted);
                setSelectedCfg(selected);
            }
            setIsLoading(false);
        }

        fetchApi();
    }, []);

    return (
        <FreteContentContainer id="frete-section">
            <Header>
                <HeaderTitle>Fretes</HeaderTitle>
            </Header>
            {isLoading ? (
                <CircularProgressIndicator />
            ) : (
                <ScrollConfig>
                    <Modal isOpen={toggle} setIsOpen={handleToggle}>
                        <FretesAddItem
                            selectedCfg={selectedCfg}
                            title={'Adicionar Frete'}
                            handlerAddItem={handlerAddItem}
                        />
                    </Modal>
                    <SectionTitles>Cobrança da entrega</SectionTitles>
                    <RadioRow
                        style={{ marginTop: 15 }}
                        onClick={() => {
                            handleChangeSelect(TIPO_FRETE.FIXO);
                        }}
                    >
                        <RadioInput
                            type="radio"
                            name="type"
                            value={TIPO_FRETE.FIXO}
                            checked={
                                selectedCfg &&
                                selectedCfg.idTipoCobrancaFrete ===
                                    TIPO_FRETE.FIXO
                            }
                            readOnly
                        />
                        Definir preço fixo para todas as entregas
                    </RadioRow>
                    {selectedCfg &&
                        selectedCfg.idTipoCobrancaFrete === TIPO_FRETE.FIXO && (
                            <FixedPrice
                                handlerFixedValue={handlerFixedValue}
                                selectedCfg={selectedCfg}
                            />
                        )}

                    <RadioRow
                        style={{ marginTop: 15 }}
                        onClick={() => {
                            handleChangeSelect(TIPO_FRETE.KM);
                        }}
                    >
                        <RadioInput
                            type="radio"
                            name="type"
                            value={TIPO_FRETE.KM}
                            checked={
                                selectedCfg &&
                                selectedCfg.idTipoCobrancaFrete ===
                                    TIPO_FRETE.KM
                            }
                            readOnly
                        />
                        Definir preço por distância
                    </RadioRow>

                    {selectedCfg &&
                        selectedCfg.idTipoCobrancaFrete === TIPO_FRETE.KM && (
                            <FreteList
                                setIsOpen={handleToggle}
                                selectedCfg={selectedCfg}
                                excludeHandler={excludeHandler}
                            />
                        )}
                    <RadioRow
                        style={{ marginTop: 15 }}
                        onClick={() => {
                            handleChangeSelect(TIPO_FRETE.VALOR);
                        }}
                    >
                        <RadioInput
                            type="radio"
                            name="type"
                            value={TIPO_FRETE.VALOR}
                            checked={
                                selectedCfg &&
                                selectedCfg.idTipoCobrancaFrete ===
                                    TIPO_FRETE.VALOR
                            }
                            readOnly
                        />
                        Definir preço por valor do pedido
                    </RadioRow>
                    {selectedCfg &&
                        selectedCfg.idTipoCobrancaFrete ===
                            TIPO_FRETE.VALOR && (
                            <FreteList
                                setIsOpen={handleToggle}
                                selectedCfg={selectedCfg}
                                excludeHandler={excludeHandler}
                            />
                        )}
                    {!!selectedCfg && (
                        <ButtonContainer>
                            <Button
                                isLoading={isLoadingSave}
                                onClick={sendChangeOption}
                                disabled={
                                    (selectedCfg &&
                                        !selectedCfg.condicaoFrete.length) ||
                                    isLoading
                                }
                                style={{
                                    fontSize: '1.5rem',
                                    fontFamile: 'NunitoSans-Regular',
                                    maxHeight: 30
                                }}
                                title={'Salvar'}
                            />
                        </ButtonContainer>
                    )}
                </ScrollConfig>
            )}
        </FreteContentContainer>
    );
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...toastActions
        },
        dispatch
    );

export const Fretes = connect(null, mapDispatchToProps)(FretesComponent);
